import { render, staticRenderFns } from "./ModalFeedbackAdd.vue?vue&type=template&id=00953699&"
import script from "./ModalFeedbackAdd.vue?vue&type=script&lang=js&"
export * from "./ModalFeedbackAdd.vue?vue&type=script&lang=js&"
import style0 from "./ModalFeedbackAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports